import { api } from '../core/api';

export const getCount = (parentId?: number) =>
  api
    .get<number>(`MonitoredProcessData/GetCount` + (parentId ? `?parentId=${parentId}` : ''))
    .then((res) => res.data);
